import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	modalTitle: {
		id: 'hub-home.unsaved-changes-modal.title.v2',
		defaultMessage: 'You have unsaved changes',
		description: 'Title for the modal asking user to confirm discarding unsaved changes',
	},
	modalDescription: {
		id: 'hub-home.unsaved-changes-modal.description.v2',
		defaultMessage:
			'If you create a new page now, your changes to this help hub will be lost.',
		description: 'Description explaining what happens if user leaves without saving',
	},
	keepEditingButton: {
		id: 'hub-home.unsaved-changes-modal.keep-editing-button',
		defaultMessage: 'Keep editing',
		description: 'Button text to continue editing without discarding changes in studio',
	},
	leaveWithoutSavingButton: {
		id: 'hub-home.unsaved-changes-modal.leave-without-saving-button',
		defaultMessage: 'Create page without saving',
		description: 'Button text to leave and discard all unsaved changes',
	},
	closeButton: {
		id: 'hub-home.unsaved-changes-modal.close-button',
		defaultMessage: 'Close dialog',
		description: 'A label for the close modal button',
	},
});

export default messages;
